import Model from "../model";
import request from "../../request/request";
import {
  EnumQuestionType,
  QuestionV2
} from "@/lib/model/exambuilder/question-v2";
import { Check } from "@/lib/enum/check";
import { Dimension } from "@/lib/dimension/dimension";
import { StructConfigGroup, StructDimensionGroupConfig } from "./configGroup";
import { AsrItem } from "@/lib/model/exam/result";
import AppendAskConfig from "./ai-ask";

export class ChoiceQuestionScore extends Model {
  optionKey = "";
  content = "";
  score = 0;
}

export class StructExamScoreConfig extends Model {
  dimensionKey = "";
  questionId = 0;
  videoQuestionScore = 0;
  dimensionScore = 0; // 冗余字段 此题目-维度分配总配分 不区分题型// 视频题/音频题 = videoQuestionScore// 选择题 = max(choiceQuestionScoreList.score)// 填空题 = sum(blankQuestionScoreList)
  choiceQuestionScoreList: ChoiceQuestionScore[] = [new ChoiceQuestionScore()];
  blankQuestionScoreList: number[] = [0]; //填空题配分列表(新增)// 当 blankQuestionConfig.scoreType == 1, 2 时 表示整体配分 //         配分列表大小必须 == 1 表示当前题目-维度分片的总配分// 当 blankQuestionConfig.scoreType == 3 时 表示按空配分
}

export class StructRandomQuestionScoreConfig extends Dimension {
  dimensionScore = 0;
}

// 面试-题目-评价配置
export class StructExamQuestionCommentConfig extends Model {
  wordLimit: number[] = [0]; //      []int  `json:"wordLimit"`       // 主答案字数限制
  appendWordLimit: number[] = [0]; // []int  `json:"appendWordLimit"` // 追问答案字数限制
  comment = ""; // string `json:"comment"`         // 评价内容
}

export class StructExamQuestionConfig extends Model {
  questionId = 0;
  questionType = 0;
  preparationTime = -1;
  answerTime = -1;
  submitNumberLimit = -1;
  openPreparationTimeSound = 2; // 是否开启准备时间提示音 默认否 012 准备时间>0可配置
  commentConfigList: StructExamQuestionCommentConfig[] = [
    new StructExamQuestionCommentConfig()
  ];
  needAskAppend = 0; // EnumBoolOption 需要使用追问
  appendScorePercent = 1; // 追问得分系数，默认写死 1
  appendMaxAskNumber = 1; // 追问最大次数
  appendAskConfig = new AppendAskConfig(); // 面试-题目追问配置
  lang = 0; // 答题语言，默认 0(中文) src/utils/multi-lang.ts

  // v1.5 版本前端使用的 是否 disabled 不可用，比如当 配置了 answerTime 的就不能开启追问
  get disabled() {
    return this.answerTime > 0;
  }
}

export class StructExamRandomConfig extends Model {
  name = "";
  questionIdList: number[] = [0];
  questionNumber = 0;
  questionType: EnumQuestionType =
    EnumQuestionType.EnumQuestionTypeSingleChoice; // 题型
  examQuestionConfig: StructExamQuestionConfig = new StructExamQuestionConfig();
  dimensionScoreConfigList: StructRandomQuestionScoreConfig[] = [
    new StructRandomQuestionScoreConfig()
  ];
  questionScore = 0;

  questionList: QuestionV2[] = []; // 这个字段不需要assign，所以不需要初始值
  totalScore = 0;
  expand = true;
  isSingleSelect() {
    return (
      this.questionType === EnumQuestionType.EnumQuestionTypeSingleChoice ||
      this.questionType === EnumQuestionType.EnumQuestionTypeNewSingleChoice
    );
  }

  isAudioQuestion() {
    return this.questionType === EnumQuestionType.EnumQuestionTypeMP3;
  }

  isBlankQuestion() {
    return this.questionType === EnumQuestionType.EnumQuestionTypeBlanks;
  }

  isVideoQuestion() {
    return (
      this.questionType === EnumQuestionType.EnumQuestionTypeVideo ||
      this.questionType === EnumQuestionType.EnumQuestionTypeVideoBody ||
      this.questionType === EnumQuestionType.EnumQuestionTypeVideoSquat
    );
  }

  getQuestionTypeText() {
    switch (this.questionType) {
      case EnumQuestionType.EnumQuestionTypeVideo:
      case EnumQuestionType.EnumQuestionTypeVideoBody:
        return "视频题";
      case EnumQuestionType.EnumQuestionTypeNewSingleChoice:
      case EnumQuestionType.EnumQuestionTypeSingleChoice:
        return "选择题";
      case EnumQuestionType.EnumQuestionTypeBlanks:
        return "填空题";
      case EnumQuestionType.EnumQuestionTypeMP3:
        return "音频题";
    }
  }
}
export class MutiChoiceOption extends Model {
  key = ""; // 选项内容
  desc = ""; // 选项描述
  type = ""; // 类型 unsetOthers 与其他选项互斥
  showDesc = false; //前端用
}
//二级单选
export class Choice2Option extends Model {
  keyList1: string[] = [""]; //一级选项
  keyList2: string[][] = [["", ""]]; //二级选项
  keyList1Chk: string[] = [""]; //复刻一下数据 表单校验用
  keyList2Chk: string[][] = [["", ""]];
}
//二级多选
export class Muti2options extends Model {
  keyList1: string[] = [""]; //一级选项
  keyList2: string[][] = [["", ""]]; //二级选项
  keyList1Chk: string[] = [""]; //复刻一下数据 表单校验用
  keyList2Chk: string[][] = [["", ""]];
}

export class MutiChoiceOption2 extends Model {}
//条件展示
export class ShowConfig extends Model {
  matchParamId = 0; //父级id 后台
  matchParamIndex = 0; //父级id (为前端新建时)
  matchType = "equal"; //父级类型 多选contains 日期dateToAgeRange
  matchValue = ""; //命中值
  fId = ""; //父字段选项id
}

export class Param extends Model {
  paramId = 0; // 登记信息id 创建场景0修改场景非0
  paramIndex = 0; //总排序

  name = ""; // 登记信息名 姓名/手机 必填
  isShow = 0; // 是否使用 1是
  isRequired = 1; // 是否必填 1是
  inputType = ""; // 输入类型 姓名->string 手机->phone
  singleChoiceOptions = [""]; // choice -> 单择选项
  fIdList = [""]; //单选选项唯一标识list
  mutiChoiceOptions: MutiChoiceOption[] = []; //多选选项
  choice2options = new Choice2Option(); //二级选项

  sort = 0; //已选排序 候选人答题端的排序 ASC 尽量互不相等 相等按paramId排序
  parentParamId = 0; // 级联登记信息-父节点id 修改场景优先id
  parentParamIndex = 0; // 级联登记信息-父节点在列表中的index 从1记 新建场景使用
  parentParamChoiceIndex = [1]; // 级联登记信息-父节点选项index 从1记 取值[1,len()]

  showConfigList: ShowConfig[][] = [[new ShowConfig()]]; //条件展示
  isHeaderOption = false; //是否由考察项转化而来的
  saveLater = 0; //后台用 1为登记后
  imageUrl = ""; //题目配图
  dateConfig = {
    dateFormat: 0,
    daysLimit: 0
  };
  interviewTimeConfig = {
    daysLimit: 3,
    timesLimit: [["09:00", "18:00"]]
  };

  public objectArrayClasses() {
    return {
      mutiChoiceOptions: MutiChoiceOption
    };
  }
}
//心理
export class MindDimension extends Model {
  isLeaf = 1; // 是否是叶子节点 1是  2不是
  psycGaugeDimensionDesc = "";
  psycGaugeDimensionId = 0;
  psycGaugeDimensionName = "";
  questionCount = 0;
  subDimensionList: MindDimension[] = [];

  public objectArrayClasses() {
    return {
      subDimensionList: MindDimension
    };
  }
}

export class PsycGaugeConfig extends Model {
  psycGaugeId = 0; //1 大五  2 xx  3 DISC 4类似大五
  psycGaugeName = "";
  psycGaugeSubDimensionIdList: number[] = [0];
  dimensionList: MindDimension[] = [];
  mustChoiceAll = 0; // 是否必须全选 1是  0不是
  questionCount = 0;
  descriptionDetail = "";
  descriptionImgUrl = "";
  descriptionSmall = ";";

  public objectArrayClasses() {
    return {
      dimensionList: MindDimension
    };
  }

  // 获取考察类型
  get psycType(): Check | undefined {
    const map = {
      1: Check.BIG_FIVE_240,
      3: Check.DISC,
      4: Check.BIG_FIVE_60,
      5: Check.DVF
    };

    return map[this.psycGaugeId];
  }
}

export class DimensionLevel extends Model {
  dimensionKey = "";
  level = 0;
}
//额外须知语
export class BeforeVideo extends Model {
  mainId = 0; //主id 创建传0 修改传旧id
  showWay = 2; //数据类型 1视频 2文字+生成视频 4文字+图片封面 5纯文字
  videoUrl = ""; //视频链接
  videoCoverUrl = ""; //图片链接
  text = ""; //文本内容
  videoMustPlay = 2; //视频是否强制播放 默认否
  videoMustPlayText = "须完整观看视频"; //视频强制播放提示语
  fillType = 0; //图片视频 填充类型  0横屏  1竖的
  textAlign = 0; // 布局类型 0:居中 1:居左 2:居右
  //自定义页面新增字段
  type = 0; // 功能类型    0展示信息  1手写板功能
  title = ""; // 标题富文本
  buttonText = "下一步"; // 自定义按钮名称
  buttonDurationSecond = 0; // 按钮倒计时限制
  // type == 1 手写板功能下字段
  noticeMessage = "请在规定区域内，字迹清晰地写出你的姓名"; // 小程序手写板提示信息
  needRecord = 1; // 是否需要录像
  reportPageTitle = ""; // 报告页展示名称
  needProcessBar = 2; //视频播放需要进度条 1需要

  // 通用字段
  positionType = "beforeDescBefore"; // 组件生效位置
  //  beforeDescBefore 面试须知前
  //  beforeParamPage 登记信息页前
  //  beforeSubmit 面试结束前
  //  afterXXX 对应场景的后
  // beforeQuestion 题目前
  questionIndex = 1; //题目序号
}
export class ERT extends Model {
  imgUrl = ""; // 图片链接(手写签名非录像模式)
  videoUrl = ""; // 视频链接
}
export class ExtraResult extends BeforeVideo {
  submitData = new ERT(); //候选人提交结果 ==null表示未提交
}
export class ColorConfig extends Model {
  type = 0; //0旧版综合检测 1新版色弱色盲 2专家版
  //旧版
  colorJudgeType = 0; //旧版检测通过类型 默认0:全对通过 1:允许错1题
  colorQuestionNumber = 4; // 旧版抽题数量 默认4
  //新版参数
  questionNumberForBlindness = 0; //色盲题目数量
  questionNumberForWeakness = 0; //色弱题目数量
  finishNumberLimit = 0; //提前结束连续答对数限制
  finishDifficultLevelLimit = 0; //提前结束难度限制 //1高 2中 3低 4随机
  appendDifficultLevel = 0; //未提前结束抽题难度限制 //1高 2中 3低 4随机
  showErrResMessage = false; //报告页是否展示异常明细
  showAnswerDetail = false; //报告页是否展示作答明细
}
export class PhotoConfig extends Model {
  checkFaceComplete = true; // 是否检测脸部完整性
  checkFaceAngle = false; // 是否检测脸部角度
  checkLighting = false; // 是否检测光线
  errorBehavior = 0; // 检测异常行为 0:默认 1:重拍
  numberLimit = 3; // 次数限制
}

export class StructExamDimensionConfig extends Model {
  dimensionKey = ""; //       string  `json:"dimensionKey"`       // 维度键
  appendScorePercent = 0; // float64 `json:"appendScorePercent"` // 追问得分系数
  constructor(key: string, score = 0) {
    super();
    this.dimensionKey = key;
    this.appendScorePercent = score;
  }
}

export class NoCompleteConfig extends Model {
  operate = 0; // 行为 0:忽略 1:提示 2:阻断
  numberLimit = 0; // 次数
}

// 身份信息验证(二要素核验)配置
export class NameIdCheckConfig extends Model {
  use = 2; // 是否开启功能 1 开启 2 不开启
  maxSubmitNumber = 2; // 最大重试次数
  isBlock = 1; // 身份信息验证异常超出最大重试次数终止面试，（该字段目前是前端字段，后端接口不需要）
  noticeMessage = "姓名或证件号与实际证件不匹配，请重新输入"; // 提示信息文案
}

export class FingerConfig extends Model {
  fingerCheckTestComplete = true; // 手指完整度
  fingerCheckTestFlexible = true; // 手指灵活度
  fingerCheckTestScar = true; // 手部纹身疤痕
  armCheckTestHide = false; // 手臂遮挡
  armCheckTestComplete = false; // 手臂完整度
  processVersion = 0; // 流程版本 0:手持版 1:支架板
  noArmCompleteConfig = new NoCompleteConfig(); // 手臂不完整配置
  noRollUpSleevesConfig = new NoCompleteConfig(); // 未撸起袖子配置
  wsaCodeUrl = ""; // 阻断提示二维码url
}

export class ExamV2Custom extends Model {
  lang = 0; // 用于 V1.5，v1.0 是一个冗余字段不影响
  applicationRuleList: any = null;
  examId = 0;
  isTesting = false; // 测试模式标记
  name = ""; // 面试名称
  innerName = ""; // 对内名称
  remark = ""; // 面试备注
  connectCode = "";
  positionName = "";
  // // 登记信息
  paramList: any[] = [new Param()]; // 登记信息
  captchaCheck = 2; // 校验验证码 1开
  classification = 0; // 面试类型 0:默认 1:集联面试（主面试） 2:题目包（子面试）
  // // 时间设置
  noEnding = 1; // 是否长期有效 默认1是
  beginTime = ""; // 面试开始时间
  endTime = ""; // 面试结束时间
  timeLimitGiveUp = -1; // 面试邀请有效期 -1不设置  秒
  giveUpSignIn = 1; //已签到是否自动过期(新增)
  giveUpNotSignIn = 1; // 未签到是否自动过期(新增)
  // // 宣传页设置
  publicityPageContent = ""; // 宣传介绍富文本  岗位描述
  publicityPageVideoId = ""; // 宣传介绍视频aiyunVideoId
  publicityPageVideoUrl = ""; //宣传介绍视频优先使用videoUrl 使用优先级高于videoId (用于设置默认视频/或者自定义上传后续的修改场景)
  publicityPageVideoUse = 2; // 宣传介绍视频是否使用 1开  废弃
  publicityPageVideoAutoplay = 2; // 宣传介绍视频是否自动播放 1开
  publicityPageVideoUseWhich = 0; //视频使用 0不使用 1默认视频 2自定义视频
  publicityPageVideoCoverUrl = ""; // 宣传介绍图片链接 默认的或者上传的
  publicityPageVideoCoverUse = 1; // 宣传介绍图片否使用 1开 目前必须开
  // // 面试引导语设置
  descBefore = ""; // 面试须知语富文本
  descAfter = ""; // 面试结束语富文本
  descBeforeShowWay = 0; //须知语 0虚拟面试官展示 1 默认图片展示 2自定义图片展示
  descAfterShowWay = 0; //结束语 0虚拟面试官展示 1 默认图片展示 2自定义图片展示
  descBeforeShowWayImgUrl = ""; //须知语图片url
  descAfterShowWayImgUrl = ""; //结束语图片url
  descBeforeLanguage = ""; //须知语语言 默认 "" 可选en zh
  descAfterLanguage = "";
  subExamIdList: any = null;
  // // 重复面试限制
  repeatAnswer = 1; // 是否允许重复作答 012
  // repeatAnswerLimit = 0; // 作答次数限制
  repeatAnswerLimit = 100; // 作答次数限制 暂时默认无限制
  repeatAnswerDayLimit = 1; //限制次数 的时间间隔 0 - 365 天
  repeatAnswerDayLimitSwitch = true;

  newSectionProgressUi = 1; //新版进度条开关 0关 1开
  newSectionProgressUiVersion = 0; //新版进度条UI版本 0图文 1虚拟人
  newSectionProgressUiVersionBallColor = ""; //虚拟人进度条颜色

  screenshotCheck = 2; //小程序防截屏 012
  screenshotCheckLimit = 0; // 小程序截屏检测自动交卷限制次数 2-5
  watermarkType = 0;
  screenshotProtect = 0;
  screenshotWhiteList = [""];
  mobileJoinCountCheck = 2; // 是否开启小程序跳出检测 012
  mobileJoinCountCheckLimit = 0; // 小程序跳出检测自动交卷限制次数 2-5
  isMarkDimensionScoreExam = 1; //是否开启小维度打分 12
  // // 防作弊限制
  // MobileJoinCountCheck     EnumBoolOption `json:"mobileJoinCountCheck"`     // 是否校验移动端跳出次数
  questionRandomSort = 2; // 是否题目乱序
  questionRandomSortRange = [1, 1]; // 题目乱序配置 从1记
  removeMaskTip = 2; //摘口罩提示
  cheatAlert = 2; // 防作弊提示（只在第一题前弹框提示） 1 开启 2 不开启 0 历史默认
  // // 相机设置
  beautyModel = 2; // 是否开启美颜
  // // 其他设置
  testExamId = 0; // 模拟练习面试id
  // 试卷
  dimensionKeyList: string[] = [""]; // 维度键列表
  questionIdList: number[] = [0]; // 题目id列表
  questionSelectedList: QuestionV2[] = []; // 已选题目全量list 页面步骤之间使用
  examRandomConfigList: StructExamRandomConfig[] = [
    new StructExamRandomConfig()
  ]; //抽提组件配置
  examScoreConfigList: StructExamScoreConfig[] = [new StructExamScoreConfig()]; // 分数配置
  examQuestionConfigList: StructExamQuestionConfig[] = [
    new StructExamQuestionConfig()
  ]; // 题目额外配置
  examDimensionConfigList: StructExamDimensionConfig[] = [
    new StructExamDimensionConfig("")
  ]; //维度配置
  isCandidateUsed = 0; //是否有后选人答题
  isRandomQuestions = 0; //抽题组卷开关 1开
  livenessRecognition = 2; //人脸合身开关
  lrType = 2;
  // EnumLrTypeScreenshotWithH5  EnumLrType = 1 // H5证件照+抽帧检测 改变答题入口 不依赖登记信息身份证号
  // EnumLrTypeScreenshotWithStd EnumLrType = 2 // 登记信息身份证号 + 视频题抽帧 aibuilder版本默认
  // EnumLrTypePhoto             EnumLrType = 3 // 登记信息输入身份证号 + 拍证件照 aiworker版本默认
  // EnumLrTypeReadNumber        EnumLrType = 4 // 念数字版 慎用不合规
  // EnumLrTypeSyncPhoto         EnumLrType = 5 // 登记信息输入身份证号 + 拍证件照 + 前端实时检测
  lrRetryNumberLimit = 0; // 人脸识别失败重试次数0表示不允许
  lrErrorAutoSubmit = 1; // 人脸识别失败是否自动交卷(仅lrType=6) 2 不自动交卷，1 自动交卷
  bgCheckProductId = 0; //背调服务 0关 2身份识别+社会安全 3身份识别+金融 4身份识别+社会+金融
  replacePersonCheck = 2; //换人检测 默认关

  templateName = ""; //模板名
  templateCoverUrl = ""; //模板封面
  templateId = ""; //模板id
  templateShortDesc = "";
  templateDesc = "";
  wxminiDeviceDetection = 2; //是否需要小程序设备检测
  wxminiNoiseDetection = 2; //是否需要小程序噪声检测

  configGroupId = 0; //配置包id
  configGroup: StructConfigGroup = new StructConfigGroup(); //配置包内容
  dimensionGroupConfigList: StructDimensionGroupConfig[] = [
    new StructDimensionGroupConfig()
  ]; // 维度组配置列表

  psycGaugeConfig = new PsycGaugeConfig(); //心理量表配置  0表示不选
  tacPsycGaugeConfigList: TacMindConfig[] = []; //新版心理量表配置  0表示不选
  gameTestConfig: number[] = [0]; //游戏量表配置 1打气球 2选左右 0表示不选
  timeLimitExam = 86400; //考试时长限制（秒）默认24h
  fingerTest = 2; //手部检测

  fingerConfig = new FingerConfig();

  nameIdCheckConfig = new NameIdCheckConfig();

  timeLimitExamType = 1; //限制时长类型 1:24H 2自定义 3基于面试有效期固定期限-面试结束时间(新增枚举)
  colorTest = 2; //通用色盲检测
  closeQuestionVideo = 2; //开启答题端题目视频
  needSaveVideoBeforeAutoSubmit = 2; // 小程序主动触发超时自动交卷前是否需要保存并提交录制一半的视频信息
  encodeCandidateInfo = 2; //候选人导出加密 1加密2不加密
  encodeTypeConnectCode = 0; //0展示 1不展示  编号
  encodeTypeBaseInfo = 0; //0展示 1不展示 2加密展示  个人信息
  encodeTypeOtherInfo = 0; // 0展示 1不展示   其他字段
  vipLevel = 0; // vip等级 0免费 10付费
  virVersion = 0; // 虚拟视频版本 0:默认 1:TTS+讯飞形象版 2:TTS+IVH形象版 3:IVH版
  examScene = 0; // 0通用 1校招 2社招 面试场景
  positionId = 0; //岗位id
  industryId = 0; //行业id
  dimensionLevelList: DimensionLevel[] = [new DimensionLevel()]; // 维度等级列表

  //WEB端 设置
  platformVersion = 0; //设备版本 0小程序 1web 2双开
  publicityPageContentForWeb = ""; // WEB宣传页富文本
  publicityPageVideoUrlForWeb = ""; // WEB宣传页视频链接
  publicityPageVideoUseWhichForWeb = 0; //WEB宣传视频版本 视频使用 0不使用 1默认视频 2自定义视频
  publicityPageVideoCoverUrlForWeb = ""; //WEB宣传页视频封面链接
  publicityPageVideoCoverUseForWeb = 1; // web宣传介绍图片否使用 1开 目前必须开

  descBeforeShowWayForWeb = 0; // WEB面试须知展示类型 0虚拟面试官 1默认图片 2自定义图片
  descBeforeShowWayImgUrlForWeb = ""; // WEB面试须知自定义图片链接
  descAfterShowWayForWeb = 0; // WEB面试结束展示类型 0虚拟面试官 1默认图片 2自定义图片
  descAfterShowWayImgUrlForWeb = ""; // WEB面试结束自定义图片链接
  descBeforeForWeb = ""; // WEB面试须知
  descAfterForWeb = ""; // WEB面试结束
  webJumpCheck = 2; // 是否开启web放切屏功能

  readingDetection = 2; // 念稿检测，默认关闭 1 开启 2 关闭

  descBeforeVideoMustPlay = 2; //须知语视频强制播放
  examVideoList: BeforeVideo[] = []; //额外须知语

  canOpenJoin = 1; //是否允许公开邀请 默认1允许
  // noPushMoka = 1; // 是否推送moka，默认不推送
  isNoCreateOpenJoin = 2; // 公开邀请范围 默认2所有人  1面试邀请候选人
  needParseResume = 2; //是否需要解析简历 1需要 2不需要
  parseResumeMessage =
    "请上传一份最新的简历，我们会结合你的的过往工作情况来进行面试。"; //解析简历提示语
  voiceType = "1007"; //虚拟人音色
  voiceDrive = 0; //  0文本驱动 1音频驱动
  skipParamPage = 0; //是否定向邀请候选人跳过登记信息页面 0不跳过 1跳过
  colorConfig = new ColorConfig(); //色盲配置
  faceDetection = 2; //露脸检测
  //证件照
  needSubmitPhoto = 2; //是否需要单独拍摄证件照
  photoConfig = new PhotoConfig(); //证件照配置

  showAllDimension = 2; //维度占比为0时是否展示评价 默认2（不展示）
  repeatAnswerAuditStatusPassLimit = false; // 当面试评估状态为通过时 是否限制重复面试 默认false代表不限制重复面试 true代表限制重复面试
  repeatAnswerAuditStatusRefuseLimit = false; // 当面试评估状态为拒绝时 是否限制重复面试 默认false代表不限制重复面试 true代表限制重复面试
  repeatAnswerAuditStatusWaitLimit = false; // 当面试评估状态为待定时 是否限制重复面试 默认false代表不限制重复面试 true代表限制重复面试
  repeatAnswerAuditStatusNormalLimit = false; // 当面试评估状态为未评价时 是否限制重复面试 默认false代表不限制重复面试 true代表限制重复面试

  examExpireTextMessage = ""; //面试过期提示文案
  dimensionGroupNormScoreType = 0; // 维度组常模划档方式 0:按维度组实际常模划分 1:按维度组理论常模划分

  public objectArrayClasses() {
    return {
      questionSelectedList: QuestionV2,
      examVideoList: BeforeVideo,
      tacPsycGaugeConfigList: TacMindConfig
    };
  }

  //新建面试
  static create(param: ExamV2Custom) {
    return request.post("aiExam/exam2/create", param).then(resp => {
      return resp;
    });
  }

  // force是否无视有候选人存在强制更新面试
  static update(param: ExamV2Custom, force = false) {
    console.log("force", force);
    if (force) {
      (param as any).force = 1;
    }
    return request.post("aiExam/exam2/update", param).then(resp => {
      return resp;
    });
  }
  static updateName(param: any) {
    return request.post("aiExam/exam2/updateName", param).then(resp => {
      return resp;
    });
  }
}

//获取公司下所有的 登记信息字段
export class RegisInfo extends Model {
  paramList: Param[] = [new Param()];
  static getAll(companyId: string) {
    return request
      .post("aiExam/exam2/defaultParams", { companyId })
      .then(resp => {
        return new RegisInfo(resp).assign(resp.data.data);
      });
  }
}

//岗位模板
export class Template extends ExamV2Custom {
  data: ExamV2Custom[] = [new ExamV2Custom()];
  static get(companyId: string) {
    return request
      .post("aiExam/exam2/defaultTemplateExams", { companyId })
      .then(resp => {
        return resp;
      });
  }
}

//心理测评量表
export class Mind extends Model {
  static get() {
    return request.post("aiExam/company/psycGaugeList", {}).then(resp => {
      return resp;
    });
  }

  static tacGet(tacToken: string) {
    return request
      .post("tac/template/redirect", {
        path: "/aiExam/company/psycGaugeList",
        tacToken,
        request: {}
      })
      .then(resp => {
        return resp;
      });
  }
}

//虚拟主播版本
export class Vir extends Model {
  canUse = 0;
  id = 0;
  imgUrl = "";
  imgUrl2 = "";
  imgUrl3 = "";
  isDefault = 0;
  name = "";
  videoUrl = "";

  static getList() {
    return request.post("aiExam/exam2/defaultVirVersions", {}).then(resp => {
      return resp.data.data.virVersionList.map((item: any) => {
        return new Vir().assign(item);
      });
    });
  }
}

// 新版心理测评结构
export class TacMind extends Model {
  canDimensionSelection = 0; // 是否需要选择维度
  canQuestionGroupSelection = 0; // 是否支持分卷
  canQuestionResort = 0; // 是否题目乱序
  descriptionDetail = ""; // 介绍
  descriptionSmall = ""; // 短介绍
  dimensionList: TacMindDimension[] = [];
  estimatedAnswerTime = 0;
  groupName = ""; // 分组名
  groupNum = 0; // 分组序号
  questionCount = 0;
  id = 0;
  introducer = ""; // 小程序介绍页
  limitAnswerTime = "";
  name = "";
  remark = "";
  studyDuides = "";

  public objectArrayClasses() {
    return {
      dimensionList: TacMindDimension
    };
  }
}

export class TacMindDimension extends Model {
  id = 0;
}

export class TacMindConfig extends Model {
  id = 0;
  segScore = [95, 90]; // 冗余字段
  questionGroupSelection = 0;
  questionResort = 0;
  dimensionParams: TacMindDimensionConfig[] = [];
  selectDimensionIds = [0];

  get segScoreStr() {
    return this.segScore.map(item => item + "%");
  }

  public objectArrayClasses() {
    return {
      dimensionParams: TacMindDimensionConfig
    };
  }
}

export class TacMindDimensionConfig extends Model {
  id = 0;
  segScore = [95, 90];
}
